import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PaymentPage from './Payment';
import './style/CreateShop.css';

export default function CreateShop() {
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [paymentRequired, setPaymentRequired] = useState(true);
    const [loading, setLoading] = useState(true);
    const [shopName, setShopName] = useState('');
    const [description, setDescription] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

 const api = "https://mkbackend-production.up.railway.app"
       useEffect(() => {
        checkPaymentAndSubscription();
    }, []);

    const checkPaymentAndSubscription = async () => {
        try {
            const token = localStorage.getItem('token');
            
            // 🔥 Check if payment is required from admin
            const paymentRes = await axios.get(`${api}/api/payment-status`);
            setPaymentRequired(paymentRes.data.paymentRequired);

            // If payment is required, check subscription
            if (paymentRes.data.paymentRequired) {
                const subRes = await axios.get(`${api}/subscription-status`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                
                if (subRes.data.success) {
                    setIsSubscribed(subRes.data.subscription.isActive);
                }
            } else {
                // 🔥 Payment NOT required - Direct access
                setIsSubscribed(true);
            }

        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    // ❌ Agar payment required hai aur subscription nahi hai toh payment page dikhao
    if (paymentRequired && !isSubscribed) {
        return <PaymentPage />;
    }

    // ✅ Agar payment required nahi hai ya subscription hai toh shop form dikhao
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!shopName.trim()) {
            setError('Shop name is required');
            return;
        }

        if (!image) {
            setError('Shop image is required');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const formData = new FormData();
            formData.append('shopName', shopName);
            formData.append('description', description);
            formData.append('address', address);
            formData.append('phone', phone);
            formData.append('image', image);

            const res = await axios.post(
                `${api}/create-shop`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (res.data.success) {
                alert('🎉 Shop created successfully!');
                navigate('/allproducts');
            }

        } catch (error) {
            setError(error.response?.data?.message || 'Failed to create shop');
        }
    };

    return (
        <div className="create-shop-container">
            <div className="create-shop-card">
                <h2>🏪 Create Your Shop</h2>
                
                {/* 🔥 Show status message */}
                {paymentRequired && isSubscribed && (
                    <p className="subtitle">✅ Subscription Active! You have 1 month access.</p>
                )}
                {!paymentRequired && (
                    <p className="subtitle free">🎉 FREE! Admin has disabled payment requirement.</p>
                )}

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Shop Name *</label>
                        <input
                            type="text"
                            value={shopName}
                            onChange={(e) => setShopName(e.target.value)}
                            placeholder="Enter your shop name"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Description</label>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Describe your shop"
                            rows="3"
                        />
                    </div>

                    <div className="form-group">
                        <label>Address</label>
                        <input
                            type="text"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="Shop address"
                        />
                    </div>

                    <div className="form-group">
                        <label>Phone Number</label>
                        <input
                            type="text"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="03XX-XXXXXXX"
                        />
                    </div>

                    <div className="form-group">
                        <label>Shop Image *</label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            accept="image/*"
                            required
                        />
                        {imagePreview && (
                            <div className="image-preview">
                                <img src={imagePreview} alt="Shop preview" />
                            </div>
                        )}
                    </div>

                    <button type="submit" className="create-btn">
                        🚀 Create Shop
                    </button>
                </form>
            </div>
        </div>
    );
}